import React from 'react'

export default function ContenedorBotonesTop(props) {
    return (
        <div className="p-col p-col-auto">
                {props.children}
        </div>
    )
}
